// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

export interface Language {
  code: string
  name: string
  nativeName: string
  dir: 'ltr' | 'rtl'
}

// Add or remove entries here to control which languages the app supports.
// First entry is the fallback language.
export const SUPPORTED_LANGUAGES: readonly Language[] = [
  { code: 'en', name: 'English',  nativeName: 'English',   dir: 'ltr' },
  { code: 'es', name: 'Spanish',  nativeName: 'Español',   dir: 'ltr' },
  { code: 'hi', name: 'Hindi',    nativeName: 'हिन्दी',      dir: 'ltr' },
] as const

export const DEFAULT_LANGUAGE_CODE = 'en'
